import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom';

const Login = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');

    const navigate = useNavigate();

    const handleLogin = async (e) => {
        e.preventDefault();

        if (username === 'foundationadmin' && password === 'admin40@anvi') {
            // If they match, navigate to the dashboard
            localStorage.setItem('username', username);
            localStorage.setItem('isLoggedIn', 'true');
            navigate('/admin/dashboard');
                    window.location.reload();
        } else {
            // Optionally handle invalid login
            alert('Invalid username or password');
        }
    }

    return (
        <>
            <section className='my-5'>
                <div className='container text-center'>

                    <div className='login-form-area'>
                        <p className='sec-heading5'>Admin Login</p>

                        <form class="row g-3 my-4" onSubmit={handleLogin}>
                            <div class="col-12">
                                <input type="text" class="form-text" id="inputText4" value={username} onChange={(e) => setUsername(e.target.value)} placeholder='Username' />
                            </div>
                            <div class="col-12">
                                <input type="password" class="form-text" id="inputPassword4" value={password} onChange={(e) => setPassword(e.target.value)} placeholder='Password' />
                            </div>
                            <div class="col-12">
                                <button type="submit" class="donate-btn w-100">Login</button>
                            </div>
                        </form>
                    </div>
                    {/* login form ends */}

                </div>
            </section>
        </>
    )
}

export default Login
